import React from 'react'
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaTripadvisor, } from 'react-icons/fa';
import { PRIVACY_POLITICS_URL } from '../../../store/constans';
import { FaYoutube } from 'react-icons/fa6';
import bg from '../../../assets/pruebas/next-departures-itineraries-section.jpg';

const Footer = () => {
  return (
    <footer className="relative w-full">
      <img
        loading='lazy'
        src={bg}
        alt="Footer background"
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
      <div className="footer relative top-0 left-0 w-full h-full bg-zinc-800/40 text-white p-10">
        <aside className='w-full h-full flex flex-col justify-center items-center'>
          <div className='flex flex-col gap-8 w-full'>
            <div className='mb-3'>
              <p className='font-bold text-start'>Quito - Ecuador</p>
              <p>Leonidas Plaza N24-282 and Lizardo García</p>
              <div>
                <p>(+ 593) (2) 256 3181</p>
                <p>(+ 593) (2) 252 6938</p>
                <p>(+ 593) (2) 252 0716</p>
              </div>
            </div>
            <div>
              <p className='font-bold text-start'>Puerto Ayora - Galapagos</p>
              <p>Tomás de Berlanga 46 and Los Colonos</p>
            </div>
          </div>
        </aside>
        <nav>
          <p className="footer-title">Services</p>
          <Link to={'/'} className='link link-hover'><p>Home</p></Link>
          <Link to={'/galapagos-cruises'} className='link link-hover'><p>Galapagos cruises</p></Link>
          <Link to={'/galapagos-islands'} className='link link-hover'><p>About galapagos</p></Link>
          <Link to={'/last-minute-deals'} className='link link-hover'><p>Last minute deals</p></Link>
        </nav>
        <nav>
          <p className="footer-title">Company</p>
          <Link to={'/our-history'} className='link link-hover'><p>About us</p></Link>
          <Link to={'/contact-us'} className='link link-hover'><p>Contact us</p></Link>
          <Link to={'/galapagos-blog'} className='link link-hover'><p>Galapagos blog</p></Link>
          <Link to={'/social-responsability'} className='link link-hover'><p>Social responsability</p></Link>
        </nav>
        <nav>
          <p className="footer-title">Legal</p>
          <a href={PRIVACY_POLITICS_URL} target="_blank" rel="noopener noreferrer" className='link link-hover'>
            <p>Personal data processing policy Rolf Wittmer</p>
          </a>
        </nav>
        <nav>
          <p className="footer-title">Social</p>
          <div className="grid grid-flow-col gap-4">
            <a href='https://www.facebook.com/rolfwittmerfleet' aria-label="Visit our Facebook" target="_blank" className='cursor-pointer transform transition-transform duration-300 hover:scale-125'>
              <FaFacebook size={28} />
            </a>
            <a href='https://www.instagram.com/rolfwittmer/?fbclid=IwAR3HYrhn4JlXxwOknep7bBgLS_8aMUeVV8agIgkwDAffFEa7wSzfwWkKXbE' aria-label="Visit our Instagram" target="_blank" className='cursor-pointer transform transition-transform duration-300 hover:scale-125'>
              <FaInstagram size={28} />
            </a>
            <a href='https://www.linkedin.com/company/tip-top-travel-official/?viewAsMember=true' aria-label="Visit our LinkedIn" target="_blank" className='cursor-pointer transform transition-transform duration-300 hover:scale-125'>
              <FaLinkedin size={28} />
            </a>
            <a href='https://www.youtube.com/@rolfwittmer9103/videos' aria-label="Visit our YouTube" target="_blank" className='cursor-pointer transform transition-transform duration-300 hover:scale-125'>
              <FaYoutube size={28} />
            </a>
            <a href='https://www.youtube.com/@rolfwittmer9103/videos' aria-label="Visit our Tripadvisor" target="_blank" className='cursor-pointer transform transition-transform duration-300 hover:scale-125'>
              <FaTripadvisor size={28} />
            </a>
          </div>
        </nav>
      </div>
    </footer>

  )
}

export default Footer